{
  "version": 1,
  "asset_id": "b1eb18a1-98a9-4ea8-a8d2-9820924d1624",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/b1eb18a1-98a9-4ea8-a8d2-9820924d1624/floral-city-black-shingle-roof-installation-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/b1eb18a1-98a9-4ea8-a8d2-9820924d1624/floral-city-black-shingle-roof-installation-1200w.webp",
  "original_filename": "floral-city-black-shingle-roof-installation-1200w.webp",
  "size": 93844,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:47Z"
}
